import api from './api';

export const backupService = {
  obtenerConfig:    ()      => api.get('/backup/config'),
  guardarConfig:    (data)  => api.post('/backup/config', data),
  ejecutarAhora:    ()      => api.post('/backup/ejecutar', null, { timeout: 120000 }),
  historial:        (page = 0, size = 20) => api.get('/backup/historial', { params: { page, size } }),
  descargar:        (id)    => api.get(`/backup/descargar/${id}`, { responseType: 'blob' }),
  eliminarRegistro: (id)    => api.delete(`/backup/historial/${id}`),
  restaurar: (file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/backup/restaurar', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
